import React, { Component } from "react"
import Banner from "@atlaskit/banner"
import Button from "@atlaskit/button"
import WarningIcon from "@atlaskit/icon/glyph/warning"
import SignInIcon from "@atlaskit/icon/glyph/sign-in"

import {
  ERROR_SERVER_NOT_AVAILABLE,
  ERROR_EMAIL_EMPTY,
  ERROR_PASSWORD_EMPTY,
  ERROR_WRONG_EMAIL_OR_PASSWORD
} from "./App"

const warning_icon = (
  <WarningIcon label="Warning icon" secondaryColor="inherit" />
)
const sign_in_icon = (
  <SignInIcon label="Sign in icon" secondaryColor="inherit" />
)

class Login extends Component {
  render() {
    console.log("render Login")

    const {
      blocking_errors,
      nonblocking_errors,
      email,
      password,
      is_logging_in,
      updateEmail,
      updatePassword,
      handleLogin
    } = this.props

    var error_message = null
    if (nonblocking_errors.includes(ERROR_SERVER_NOT_AVAILABLE)) {
      error_message = ERROR_SERVER_NOT_AVAILABLE
    } else if (nonblocking_errors.includes(ERROR_WRONG_EMAIL_OR_PASSWORD)) {
      error_message = ERROR_WRONG_EMAIL_OR_PASSWORD
    } else if (nonblocking_errors.length !== 0) {
      error_message = nonblocking_errors[0]
    }

    return (
      <div
        style={{
          position: "fixed",
          top: "20%",
          left: "50%",
          padding: "10px",
          width: "400px",
          marginLeft: "-200px",
          textAlign: "left"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1>Toggl Zeitvalidierung</h1>
        </div>

        <div style={{ marginTop: "40px" }}>
          <p
            style={{
              fontSize: "13px",
              marginLeft: "20px",
              marginTop: "20px",
              color: "#777777"
            }}
          >
            <b>E-Mail</b>
          </p>
        </div>
        <div>
          <input
            className="inputLogin"
            type="text"
            style={
              blocking_errors.includes(ERROR_EMAIL_EMPTY)
                ? { borderColor: "red", borderWidth: "3px" }
                : {}
            }
            value={email}
            onKeyPress={evt => {
              evt.key === "Enter" && handleLogin()
            }}
            onChange={arg => updateEmail(arg)}
          />
        </div>
        <div>
          <p
            style={{
              fontSize: "13px",
              marginLeft: "20px",
              marginTop: "20px",
              color: "#777777"
            }}
          >
            <b>Passwort</b>
          </p>
        </div>
        <div>
          <input
            className="inputLogin"
            type="password"
            style={
              blocking_errors.includes(ERROR_PASSWORD_EMPTY)
                ? { borderColor: "red", borderWidth: "3px" }
                : {}
            }
            value={password}
            onKeyPress={evt => {
              evt.key === "Enter" && handleLogin()
            }}
            onChange={arg => updatePassword(arg)}
          />
        </div>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <Button
            className="buttonLogin"
            appearance={"primary"}
            isLoading={is_logging_in}
            iconBefore={sign_in_icon}
            onClick={handleLogin}
          >
            Anmelden
          </Button>
        </div>
        {error_message && (
          <Banner icon={warning_icon} isOpen={true} appearance="error">
            {error_message}
          </Banner>
        )}
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login.jsx